// extracted by mini-css-extract-plugin
export default {"labelWrapper":"PasswordConfirm_labelWrapper_DcaPW","pwdLabel":"PasswordConfirm_pwdLabel_qm2Ia"};